/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: {
        container: {
            minWidth: 'xs',
            width: 'full',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            display: {base: 'none', lg: 'flex'}
        },
        stackContainer: {
            whiteSpace: 'nowrap',
            flexWrap: 'wrap'
        },
        popoverContainer: {
            transform: 'unset',
            paddingTop: 4,
            paddingRight: 6,
            paddingBottom: 8,
            paddingLeft: 6,
            maxWidth: 'container.xxxl'
        },
        popoverContainerWithImages: {
            display: 'flex',
            overflow: 'hidden'
        },
        imageBlockContainer: {
            display: 'flex',
            gap: 2,
            flexWrap: 'no-wrap',
            justifyContent: 'end',
            flex: '1'
        },
        popoverContent: {
            marginLeft: 'auto',
            marginRight: 'auto',
            border: 0,
            minWidth: '100%',
            top: '-8px',
            position: 'absolute'
        },
        popoverBody: {
            padding: 0,
            boxShadow: 'xl',
            zIndex: 1,
            maxHeight: 'calc(100vh - 80px)',
            overflow: 'auto',
            boxShadow: 'none',
            border: '0',
            borderRadius: '0'
        },
        popoverOverlay: {
            position: 'fixed',
            top: '40px',
            left: '0',
            width: '100vw',
            height: '100vh',
            bg: '#FFFFFF66',
            zIndex: '-1',
            backdropFilter: 'blur(20px)'
        },
        listMenuTriggerContainer: {
            display: 'flex',
            alignItems: 'center'
        },
        listMenuTriggerLink: {
            display: 'block',
            fontSize: 'sm',
            paddingLeft: 3,
            paddingRight: 3,
            paddingTop: '17px',
            paddingBottom: '17px',
            lineHeight: '100%',
            letterSpacing: '0px',
            whiteSpace: 'nowrap',
            position: 'relative',
            fontWeight: 'medium',
            _hover: {
                textDecoration: 'none'
            }
        },
        listMenuTriggerLinkActive: {
            textDecoration: 'none',
            paddingLeft: 3,
            paddingRight: 3,
            _before: {
                content: '""',
                position: 'absolute',
                bottom: '6px',
                width: '100%',
                zIndex: 1001,
                backgroundColor: 'black',
                height: '1px',
                color: 'transparent',
                left: 'auto',
                maxWidth: 'calc(100% - 24px)' // removed the paddingLeft + paddingRight
            }
        },
        level1Label: {
            fontSize: '10px',
            lineHeight: '100%',
            letterSpacing: '0px',
            textTransform: 'uppercase',
            color: 'gray.700',
            marginBottom: 6,
            fontWeight: 'bold'
        },
        linkSeparator: {
            _after: {
                content: '"-"',
                display: 'block',
                marginTop: '20px',
                marginBottom: '20px',
                fontSize: 'sm',
                lineHeight: '100%',
                fontWeight: 'medium'
            }
        }
    },
    parts: [
        'container',
        'stackContainer',
        'popoverContent',
        'popoverContainer',
        'listMenuTriggerContainer',
        'listMenuTriggerLink',
        'listMenuTriggerLinkActive',
        'listMenuTriggerIcon'
    ]
}
